module.exports = __webpack_public_path__ + "static/media/harris_farm_back.eecbfc0d.png";